module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.47bded21.png";